import styles from "./Tutorial.module.css";
import EmojiText from "../utils/EmojiText";
import AppState from "state/AppState";
// import ImageTapHand from "images/shell/icon-tap-hand.png";

import React, { useRef, useState, useEffect, useCallback } from "react";
import { observer } from "mobx-react-lite";
import classnames from "classnames";

const ImageTapHand =
    "data:image/png;base64,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";

export const StoryTutorial = observer(() => {
    const nextHandler = useCallback(() => AppState.tutorialNext(), []);

    const tutorial = AppState.storyState?.tutorial || AppState.story?.tutorial;
    if (!tutorial || tutorial.length === 0) {
        return null;
    }

    const step = AppState.storyState.tutorialStep;
    if (step >= tutorial.length) {
        // tutorial done, remove completely
        return null;
    }

    const {
        element_id: elementId,
        text,
        require_element_click: requireElementClick,
    } = tutorial[step];
    const isLastStep = step === tutorial.length - 1;

    return (
        <TutorialStep
            elementId={elementId}
            text={text}
            isFirstStep={step === 0}
            requireElementClick={requireElementClick}
            nextText={isLastStep ? "Got it!" : "OK"}
            onNext={nextHandler}
        />
    );
});

export const TutorialStep = ({
    elementId,
    text,
    nextText,
    requireElementClick,
    isFirstStep,
    rectangular,
    glow,
    onNext,
}) => {
    const rootRef = useRef();
    const allowNextRef = useRef(true);
    const [[circlePosition, tooltipPosition], setPosition] = useState([]);

    const updatePossition = useCallback(() => {
        setPosition(
            calculatePositions(elementId, rootRef.current, rectangular)
        );
    }, [elementId, rectangular]);

    useEffect(() => {
        updatePossition();
        const interval = setInterval(updatePossition, 1000);
        return () => clearInterval(interval);
    }, [updatePossition]);

    const nextClickHandler = (evt) => {
        evt.stopPropagation();

        if (allowNextRef.current) {
            allowNextRef.current = false;
            setTimeout(() => {
                allowNextRef.current = true;
            }, 500);
            onNext();
        }
    };

    const circleClickHandler =
        elementId && requireElementClick
            ? () => {
                  const element = document.getElementById(elementId);
                  if (element) {
                      element.click();
                  }
                  onNext();
              }
            : undefined;

    return (
        <div
            className={classnames(
                styles.tutorial,
                circlePosition ? null : styles.noCircle,
                isFirstStep ? styles.firstStep : null,
                tooltipPosition ? null : styles.hidden
            )}
            ref={rootRef}
        >
            <div className={styles.tooltip} style={tooltipPosition}>
                <EmojiText text={text} />
                {requireElementClick ? null : (
                    <div
                        className={styles.tooltip__button}
                        onClick={nextClickHandler}
                    >
                        {nextText}
                    </div>
                )}
            </div>
            {circlePosition ? (
                <div
                    className={classnames(
                        styles.circle,
                        glow ? styles.glow : null
                    )}
                    style={circlePosition}
                    onClick={circleClickHandler}
                >
                    {requireElementClick ? (
                        <img
                            src={ImageTapHand}
                            alt=""
                            className={styles.circle__tapIcon}
                        />
                    ) : null}
                </div>
            ) : null}
        </div>
    );
};
TutorialStep.defaultProps = {
    nextText: "Next",
    glow: true,
};

function calculatePositions(elementId, rootElement, isRectangular) {
    // returns [circlePosition, tooltipPosition]

    if (!rootElement) {
        return [];
    }
    const rootRect = rootElement.getBoundingClientRect();

    if (!elementId) {
        const middleHeight = rootRect.height / 2;
        return [
            null,
            {
                transform: `translateY(calc(${middleHeight}px - 50%))`,
            },
        ];
    }

    const element = document.getElementById(elementId);
    if (!element) {
        return [];
    }

    const rect = element.getBoundingClientRect();
    const scaleFactor = 1.05;
    const diameter = Math.max(rect.width, rect.height) * scaleFactor;
    const height = isRectangular ? rect.height * scaleFactor : diameter;
    const width = isRectangular ? rect.width * scaleFactor : diameter;

    const circleTop = rect.top - rootRect.top + rect.height / 2 - height / 2;
    const circleLeft = rect.left - rootRect.left + rect.width / 2 - width / 2;

    const circlePosition = {
        top: circleTop,
        left: circleLeft,
        width,
        height,
        borderRadius: isRectangular ? 10 : diameter,
    };

    const tooltipPosition =
        circleTop < rootRect.height / 2
            ? {
                  transform: `translateY(${circleTop + height + 15}px)`,
              }
            : {
                  transform: `translateY(calc(-100% + ${circleTop - 10}px)`,
              };

    return [circlePosition, tooltipPosition];
}
